import { Link } from "react-router-dom";
import styles from "./NotFoundPage.module.css";

export function NotFoundPage() {
  return (
    <main className={styles.page}>
      <span>404</span>
      <h1>페이지를 찾을 수 없습니다.</h1>
      <Link to="/">포트폴리오로 돌아가기 ↗</Link>
    </main>
  );
}
